import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { findReducedPriceOrInitialize } from "@circle-react/helpers/paywallCustomizationHelpers";
import { useGetPaywallsCurrencies } from "@circle-react/hooks/paywalls/useGetPaywallsCurrencies";
import type { PaywallCurrency } from "@circle-react/types";
import { StripePricingTabContextProvider } from "../../../PricingTab/StripePricingTab/hooks/usePricingTabContext";
import { useCheckoutTabContext } from "../../CheckoutTabContext";
import { PriceForm } from "./PriceForm";

export const ReducedPricesForm = () => {
  const { reducedPricePropertiesForm } = useCheckoutTabContext();
  const { watch, setValue, getValues } = useFormContext();

  const currencyId = Number(getValues("currency_id"));
  const currenciesQuery = useGetPaywallsCurrencies();
  const currency = (currenciesQuery?.data || []).find(
    (currency: PaywallCurrency) => currency.id === currencyId,
  );

  const stripePrices = watch("stripe_prices_attributes");
  useEffect(() => {
    if (currency) {
      setValue(
        "paywall_customization_attributes.reduced_price_properties.prices",
        findReducedPriceOrInitialize(
          stripePrices,
          reducedPricePropertiesForm?.fields || [],
          currency,
        ),
      );
    }
  }, []);

  if (!currency) {
    return null;
  }

  return (
    <StripePricingTabContextProvider currency={currency}>
      <div className="flex flex-col pb-[12rem]">
        {reducedPricePropertiesForm?.fields?.map(
          (price: any, index: number) => (
            <PriceForm key={price.id} reducedPrice={price} index={index} />
          ),
        )}
      </div>
    </StripePricingTabContextProvider>
  );
};
